import * as Sentry from '@sentry/react';

/**
 * Sentry error monitoring — initialised before React renders so no errors
 * are missed. DSN is on the EU ingest region (ingest.de) for GDPR compliance.
 *
 * To view errors: https://oliver-tracker.sentry.io (or your Sentry org URL)
 */
Sentry.init({
  dsn: 'https://cc11bf00f8c8f6446210329272ba11a3@o4511248310272000.ingest.de.sentry.io/4511248311976016',

  // Tag events by environment so production errors don't mix with local dev noise
  environment: process.env.NODE_ENV,

  // Capture 20% of sessions for performance traces — enough signal without
  // burning through the free tier quota. Raise to 1.0 if debugging perf issues.
  tracesSampleRate: 0.2,

  // Send IP address + user agent. Users consented to this via the privacy
  // policy checkbox at signup (privacyConsentAt stored in Firestore).
  sendDefaultPii: true,

  // Browser noise that produces no actionable signal
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Network request failed',
    'Failed to fetch',
    'Load failed',            // Safari's generic network error
    'ChunkLoadError',         // stale tab after a new deploy — harmless
  ],
});
